import { render, staticRenderFns } from "./PractitionersResults.vue?vue&type=template&id=3c98a218"
import script from "./PractitionersResults.vue?vue&type=script&lang=js"
export * from "./PractitionersResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports